import { render, staticRenderFns } from "./ForestPlatformEdit.vue?vue&type=template&id=3a74aa67&"
import script from "./ForestPlatformEdit.vue?vue&type=script&lang=js&"
export * from "./ForestPlatformEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports